import { render, staticRenderFns } from "./ModalDocumentsUpload.vue?vue&type=template&id=351ec29a&scoped=true&"
import script from "./ModalDocumentsUpload.vue?vue&type=script&lang=js&"
export * from "./ModalDocumentsUpload.vue?vue&type=script&lang=js&"
import style0 from "./ModalDocumentsUpload.vue?vue&type=style&index=0&id=351ec29a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351ec29a",
  null
  
)

export default component.exports